import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { ServiceFilter } from 'src/app/model/service-filter';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterService } from 'src/app/services/filter.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { PatientSearch } from 'src/app/model/patient';
import { CenterFilter } from '../../../model/center-filter';
import { AdmissionService } from '../../../services/admission.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';

@Component({
  selector: 'app-admision-re-appointment-filter',
  templateUrl: './admision-re-appointment-filter.component.html',
})
export class AdmisionReAppointmentFilterComponent implements IFilterComponent, OnInit {

  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  serviceFilters: ServiceFilter[] = [];
  centerFilters: CenterFilter[] = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private notificationToastService: NotificationToastService
    , private filterRecordService: FilterRecordService
    , private admissionService: AdmissionService) {

    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Patient: [null],
      Centers: [''],
      Services: [''],
      ViewCancel: [false],
      ReAppointmentPendient: [true],
      ReAppointment: [false],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('DateFrom');
    requiredTags.push('DateTo');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('AdmisionReAppointmentFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('AdmisionReAppointmentFilterComponent', this.form);
  }

  async search(): Promise<any> {


      const serviceIds = [];
      const centerIds = [];

      if (this.form.controls.Services.value) {
        this.form.controls.Services.value.forEach(element => {
          serviceIds.push(element.Id);
        });
      }

      if (this.form.controls.Centers.value) {
        this.form.controls.Centers.value.forEach(element => {
          centerIds.push(element.Id);
        });
      }
      const reApointmentPendiet = this.form.controls.ReAppointmentPendient.value ? this.form.controls.ReAppointmentPendient.value : false;
      const reAppointment = this.form.controls.ReAppointment.value ? this.form.controls.ReAppointment.value : false;

      if (!reApointmentPendiet && !reAppointment) {
        this.notificationToastService.error('Debe seleccionar algún estado de recitado', 'Búsqueda');
        return [];
      } else {
        return await this.admissionService.getReAppointmentItemsByParameters(
          <Date>this.form.controls.DateFrom.value,
          <Date>this.form.controls.DateTo.value,
          serviceIds,
          centerIds,
          this.form.controls.ViewCancel.value ? this.form.controls.ViewCancel.value : false,
          reApointmentPendiet,
          reAppointment,
         (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null));
      }

  }

  async ngOnInit() {
    this.filterService.getCentersFilter().then((centers) => {
      this.centerFilters = centers;
    });

    this.filterService.getServicesFilter().then((services) => {
      this.serviceFilters = services;
    });
  }
}
